import { SkyscannerSonarV3alpha1Api } from '@skyscanner-internal/sonar-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';
import {
  CreateSessionAffinityMiddleware,
  PollSessionAffinityMiddleware,
} from '../internals/clients/grpc/sessionAffinityMiddleware';

import { GRPC_SONAR_TIMEOUT_MS } from './sonar';

import type {
  SkyscannerSonarV3alpha1Request,
  SkyscannerSonarV3alpha1Response,
} from '@skyscanner-internal/sonar-web-http-client';

type SonarV3AlphaPollRequest = SkyscannerSonarV3alpha1Request.PollAlphaRequest;
type SonarV3AlphaPollResponse = SkyscannerSonarV3alpha1Response.PollAlphaResponse;
type SonarV3AlphaCreateSessionRequest = SkyscannerSonarV3alpha1Request.CreateSessionAlphaRequest;
type SonarV3AlphaCreateSessionResponse = SkyscannerSonarV3alpha1Response.CreateSessionAlphaResponse;

const GRPC_POLL_V3_ALPHA_CLIENT_NAME = 'SONAR_V3_POLL_ALPHA';
const GRPC_V3_ALPHA_CREATE_SESSION_CLIENT_NAME = 'SONAR_V3_ALPHA_CREATE_SESSION';

const createSessionAffinityMiddleware = new CreateSessionAffinityMiddleware();
const pollSessionAffinityMiddleware = new PollSessionAffinityMiddleware(
  createSessionAffinityMiddleware.getRegion.bind(createSessionAffinityMiddleware),
);

export const sonarV3PollAlphaRequest = grpcFetchClientWrapper<
  SonarV3AlphaPollRequest,
  SonarV3AlphaPollResponse
>(SkyscannerSonarV3alpha1Api.AlphaItineraryService.PollAlpha, {
  clientName: GRPC_POLL_V3_ALPHA_CLIENT_NAME,
  pathPrefix: '/g/sonar',
  betaInterceptors: [pollSessionAffinityMiddleware],
  timeoutMs: GRPC_SONAR_TIMEOUT_MS,
});

export const sonarV3AlphaCreateRequest = grpcFetchClientWrapper<
  SonarV3AlphaCreateSessionRequest,
  SonarV3AlphaCreateSessionResponse
>(SkyscannerSonarV3alpha1Api.AlphaItineraryService.CreateSessionAlpha, {
  clientName: GRPC_V3_ALPHA_CREATE_SESSION_CLIENT_NAME,
  pathPrefix: '/g/sonar',
  betaInterceptors: [createSessionAffinityMiddleware],
  timeoutMs: GRPC_SONAR_TIMEOUT_MS,
});
